<template>
    <div class="price-box">
        <h3>价格区间<span :class="priceRange[0]&&'active'">¥{{priceRange[1]}}</span></h3>
        <div class="price-line">
            <span><span>0</span></span>
            <span><span>500</span></span>
            <span><span>1000</span></span>
            <span><span>1500</span></span>
            <span><span>2000</span></span>
        </div>
        <div class="price-slider">
            <van-slider 
                v-model="value" 
                range 
                :step="5"
                active-color="#108B30"
                @change="onChange" 
            >
                <template #button>
                    <div class="slider">
                        <img src="@/assets/hotel/img/search/slider.png" alt="slider">
                    </div>
                </template>
            </van-slider>
            <div class="price-block">
                <span
                    v-for="(item,index) of 5"
                    :key="index"
                    :class="priceChunk[index]&&'unactive'"
                ></span>
            </div>
        </div>
        <div class="btn">
            <div 
                :class="priceActive==1&&'active'"
                @click="setPrice(1,0,200)">¥200 以下</div>
            <div 
                :class="priceActive==2&&'active'"
                @click="setPrice(2,200,300)">¥200-300</div>
            <div 
                :class="priceActive==3&&'active'"
                @click="setPrice(3,200,400)">¥200-400</div>
            <div 
                :class="priceActive==4&&'active'"
                @click="setPrice(4,400,600)">¥400-600</div>
            <div 
                :class="priceActive==5&&'active'"
                @click="setPrice(5,600,800)">¥600-800</div>
            <div 
                :class="priceActive==6&&'active'"
                @click="setPrice(6,800,2000)">¥800以上</div>
        </div>
        <h3>星级档次</h3>
        <div class="btn">
            <div
                :class="ratingActive.includes(2)&&'active'"
                @click="setRating(2)">二星及以下经济</div>
            <div
                :class="ratingActive.includes(3)&&'active'"
                @click="setRating(3)">三星舒适</div>
            <div
                :class="ratingActive.includes(4)&&'active'"
                @click="setRating(4)">四星高档</div>
            <div
                :class="ratingActive.includes(5)&&'active'"
                @click="setRating(5)">五星豪华</div>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'
    export default {
        data() {
            return {
                value:[0,100],//滑块两端数值
                dom:[],//滑块上方价格dom
                priceActive:0,//价格选中
                ratingActive:[],//星级选中
                initLock:true,//初始化锁
                priceChunk:[true,false,false,false,true],
            }
        },
        computed:{
            ...mapState({
                levelActive:state => state.hotel.levelActive,
            }),
            priceRange(){
                let active = false;
                if(this.value[0]==0&&this.value[1]==100){
                    active = false;
                }else{
                    active = true;
                }
                return [active,`${this.value[0]*20} - ${this.value[1]*20}`]
            },
        },
        mounted() {
            //设置滑块两端的数值
            setTimeout(()=>{
                let slider1 = document.getElementsByClassName('slider')[0].children[0];
                let slider2 = document.getElementsByClassName('slider')[1].children[0];
                this.dom[0] = slider1; this.dom[1] = slider2;
                slider1.innerHTML  = `¥${this.value[0]*20}`;
                slider2.innerHTML  = `¥${this.value[1]*20}`;
            },1)
            //初始化
            if(this.levelActive){
                this.value = this.levelActive[0];
                this.ratingActive = this.levelActive[1];
                this.setPriceBtn();
                this.initLock = false;
            }
        },
        methods: {
            ...mapMutations(['setState']),
            onChange(value) {
            },
            setPrice(idx,min,max){//直接设置价格区间
                if(idx == this.priceActive){
                    this.priceActive = 0;
                    this.value = [0,100];
                    return false;
                }
                this.priceActive = idx;
                this.value = [min/20,max/20];

            },
            setPriceBtn(){//设置价格区间按钮
                if(this.value[0]==0&&this.value[1]<=10){
                    this.priceActive = 1;
                }else if(this.value[0]==10){
                    if(this.value[1]==15){
                        this.priceActive = 2;
                    }else if(this.value[1]==20){
                        this.priceActive = 3;
                    }else{
                        this.priceActive = 0;
                    }
                }else if(this.value[0]==20&&this.value[1]==30){
                    this.priceActive = 4;
                }else if(this.value[0]==30&&this.value[1]==40){
                    this.priceActive = 5;
                }else if(this.value[0]>=40){
                    this.priceActive = 6;
                }else{
                    this.priceActive = 0;
                }
                
            },
            setRating(idx){//直接设置星级
                if(this.ratingActive.includes(idx)){
                    let index = this.ratingActive.indexOf(idx);
                    this.ratingActive.splice(index,1);
                    return false;
                }
                this.ratingActive.push(idx);
            }, 
            setPriceStyle(){//设置价格点
                let minP = Math.floor(this.value[0]/25);
                let maxP = Math.floor(this.value[1]/25);
                for(let i=0,len = this.priceChunk.length;i<len;i++){
                    if(i>minP&&i<=maxP){
                        this.$set(this.priceChunk,i,false);
                    }else{
                        this.$set(this.priceChunk,i,true);
                    }
                }
            },
            confirm(){//确认
                this.setState([{name:'levelActive',value:[this.value,this.ratingActive]}]);
                if(this.ratingActive.length==0&&(this.value[0]==0&&this.value[1]==100)){
                    return false;
                }else{
                    return [this.value[0]*20,this.value[1]*20,this.ratingActive]
                }
            },
            reset(){//重置
                this.value = [0,100];
                this.priceActive = 0;
                this.ratingActive = [];
                this.setState([{name:'levelActive',value:null}]);
            }
        },
        watch:{
            value(){
                if(!this.initLock){
                    this.initLock = true;
                    return false;
                }
                this.setPriceStyle();
                this.setPriceBtn();
            }
        }
    }
</script>

<style lang="less" scoped>
    .price-box{
        padding: 0 2rem;
        padding-top: 0.5rem;
        .price-slider{
            margin-bottom: 4.4rem;
            margin-top: 2rem;
            padding: 0 1.5rem;
            position: relative;
            .slider{
                position: relative;
                z-index: 1;
                font-size: 0;
                img{
                    width: 3rem;
                    height: 3rem;
                }
                span{
                    position: absolute;
                    left: 50%;
                    bottom: 5rem;
                    transform: translateX(-50%);
                    font-size: 1.3rem;
                    line-height: 1.8rem;
                    color: #333333;
                }
            }
            .price-block{
                width:100%;
                display: flex;
                justify-content: space-between;
                box-sizing: border-box;
                position: absolute;
                left: 0;
                top: 0;
                z-index: -1;
                padding: 0 1.5rem;
                span{
                    height: 0.6rem;
                    width: 0.6rem;
                    border-radius: 50%;
                    background-color: rgb(16, 139, 48);
                    transition: all 0.2s;
                    position: relative;
                    top: -0.2rem;
                    &.unactive{
                        background-color: #F0F0F0 !important;
                    }
                }
            }
        }
        h3{
            font-size: 1.5rem;
            font-weight: 500;
            color: #333333;
            line-height: 2.1rem;
            margin-bottom: 2rem;
            span{
                font-size: 1.3rem;
                font-weight: 400;
                line-height: 1.8rem;
                margin-left: 1rem;
                color: #999999;
                &.active{
                    color: #108B30;
                    font-weight: 500;
                }
            }
        }
        .btn{
            margin-bottom: 2rem;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            div{
                width: 10.5rem;
                height: 3.6rem;
                background-color: #EEEEEE;
                border-radius: 1.8rem;
                line-height: 3.7rem;
                text-align: center;
                font-size: 1.3rem;
                color: #333333;
                &:not(:nth-last-child(-n+3)){
                    margin-bottom: 1rem;
                }
                &.active{
                    background-color: #108B30;
                    color: #fff;
                }
            }
        }
    }
    .price-line{
        // background-color: rgb(16, 139, 48);
        margin: 3.5rem 1.5rem 2.5rem 1.5rem;
        height: 0.1rem;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        >span{
            height: 0.4rem;
            width: 0.1rem;
            // background-color: rgb(16, 139, 48);
            position: relative;
            top: -0.4rem;
            >span{
                position: absolute;
                top: -1.6rem;
                left: 50%;
                transform: translateX(-50%);
                text-align: center;
            }
        }
        
    }
</style>